export default "__VITE_ASSET__DrJknqz2__"